var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preview-image-container"},[_c('el-image',{ref:"elImageRef",attrs:{"src":_setup.srcList[0] || _setup.defaultImg,"preview-src-list":_setup.srcList,"z-index":10000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }